import { render } from "./HelpRequestGeneric.vue?vue&type=template&id=2b6ac652"
import script from "./HelpRequestGeneric.vue?vue&type=script&lang=js"
export * from "./HelpRequestGeneric.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__